import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { SortDirection } from './sort-header.types';

/**
 * The label and sort icon of one sortable column header — a pure view.
 *
 * The icon is the project overview's (`assets/hamIcons/chevron-sort*.svg`): two chevrons, both grey
 * while the column is not sorted, the active one dark once it is. Drawn inline rather than loaded from
 * those files, so it renders the same in the app and in the component lab, whose assets do not
 * include them.
 *
 * It only reports the click. Which direction comes next is the table's decision (`nextSort`), and
 * `aria-sort` belongs on the `<th>` around it, which this component cannot reach.
 */
@Component({
    selector: 'abcp-sort-header',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './sort-header.component.html',
    styleUrls: ['./sort-header.component.scss'],
})
export class AbcpSortHeaderComponent {
    /** The direction this column is sorted in, or `null` when another column (or none) is. */
    @Input() direction: SortDirection | null = null;

    /** Follows the column's own alignment, so a centred or right-aligned column keeps its label there. */
    @Input() align: 'start' | 'center' | 'end' = 'start';

    @Output() sortClick = new EventEmitter<void>();
}
